// @flow

import Model from "app/models/Model";

export default class Tag extends Model {
    rowid: number;
    name: string;
}



// WEBPACK FOOTER //
// ./src/app/models/Tag.js